import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useEffect, useRef} from "react";
import {SuMMARY_DEFAULT} from "../../actions/path";
import profilePhoto from "../../assets/profilephoto.jpg";
import Summary from "./index";

const Others = ({allMode = false}) => {

    // 페이지 이동하려면 사용해야 되는
    const currentPathSelector = useSelector(state => state.pathReducers.currentPath);
    const dispatch
        = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        navigate(currentPathSelector);
    }, [currentPathSelector]);
    // ---------------------------------

    const goToSummartDefault = (e) => {
        e.preventDefault();
        dispatch({type: SuMMARY_DEFAULT});
    }


    const stickerItemList = [
        {
            imagePath: profilePhoto,
        },
    ]

    const othersInfo = {
        initTitle : ' 저에 대해 설명드리겠습니다.'
    }

    const commonStudyTitle = '🎓 교육 (Education)';
    const certificationTitle = '🪪 자격증 (Certifications)';
    const commonSkillsTitle= '🛠️ 기술 (Skills)';

    const studyList = [
        {
            content:'"실무 프로젝트 기반 빅데이터 서비스 솔루션 개발자 양성과정 4기" Java 기반 풀스택 프로그래밍 과정',
            period:'2023.01 ~ 2023.08',
            server: '쌍용강북교육센터',
        },
        {
            content:'Front-End 입문을 위한 HTML5 웹프로그래밍',
            period:'2022.12 ~ 2023.01',
            server: '인천대학교',
        }
    ]

    const certificationList = [
        {
            content:'토익스피킹 IH(150)',
            period:'2025.12',
        },
        {
            content:'정보처리기사',
            period:'2023.11',
        },
        {
            content:'파이썬 마스터 3급',
            period:'2023.09',
        },
        {
            content:'SQLD (SQL 개발자)',
            period:'2023.07',
        },
        {
            content:'산업안전산업기사',
            period:'2022.09',
        },
        {
            content:'워드프로세서',
            period:'2022.02',
        },
        {
            content:'운전면허 (1종 보통)',
            period:'2018.04',
        }
    ]

    const skillList = [
        {
            type: 'fe',
            name: 'React',
        },
        {
            type: 'fe',
            name: 'JS',
        },
        {
            type: 'be',
            name: 'JAVA',
        },
        {
            type: 'be',
            name: 'Spring',
        },
        {
            type: 'be',
            name: 'MyBatis',
        },
        {
            type: 'be',
            name: 'JPA',
        },
        {
            type: 'db',
            name: 'Oracle',
        },
        {
            type: 'db',
            name: 'MySQL',
        },
        {
            type: 'os',
            name: 'Windows',
        },
        {
            type: 'os',
            name: 'Linux',
        },
        {
            type: 'solution',
            name: 'AEM',
        },
        {
            type: 'solution',
            name: 'AWS',
        }
    ]

    const skillClassMapData = {
        fe: 'badge d-flex align-items-center p-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill',
        be: 'badge d-flex align-items-center p-1 pe-2 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-pill',
        db: 'badge d-flex align-items-center p-1 pe-2 text-info-emphasis bg-info-subtle border border-info-subtle rounded-pill',
        os: 'badge d-flex align-items-center p-1 pe-2 text-dark-emphasis bg-light-subtle border border-dark-subtle rounded-pill',
        solution: 'badge d-flex align-items-center p-1 pe-2 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill',
    }

    const activeTarget = 'choice-summary-3';
    const focusRef = useRef();
    useEffect(() => {
        if (allMode) return;
        document.querySelector(`#${activeTarget}`)?.classList?.add('border-primary');
        focusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    },[]);

    return (
        <>
            {!allMode && (
                <Summary/>
            )}
            <div className='container' ref={focusRef}>
                <hr className='featurette-divider'/>
                <div className='right-align'>
                    <h2><a className='no-line-href fold-btn margin-right-3vh' href='#' onClick={goToSummartDefault}>🔺접기</a></h2>
                </div>
                <div className="code-bg px-4 pt-5 my-5 text-center border-bottom">
                    <h1 className="code-index typing">
                        {othersInfo.initTitle}
                    </h1>
                    {/**/}
                    <div className="row">
                        {stickerItemList.map((item, index) =>
                            <div className="center-align col-lg-12"
                                key={`sticker-${index+1}`}>
                                <img
                                    aria-label="Placeholder"
                                    className="bd-placeholder-img rounded-circle"
                                    height="170"
                                    width="140"
                                    preserveAspectRatio="xMidYMid slice"
                                    role="img"
                                    // xmlns="http://www.w3.org/2000/svg"
                                    src={item.imagePath}
                                >
                                </img>
                                <h2 className="fw-normal">{item.heading}</h2>
                                <div>
                                    <p><span className='code-orange'>This is</span>
                                        <span className='font-highlight'> me</span> = {`{`}</p>
                                    <p>이름: "이준복"</p>
                                    <p>생년월일: "1996.07.16"</p>
                                    <p>대학교: "인천대학교(물리학과) 졸업"</p>
                                    <p>이메일: "leejb0011@naver.com"</p>
                                    <p>{`}`}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* 교육 */}
                <hr/>
                <div className="col-lg-6 mx-auto">
                    <h2>
                        {commonStudyTitle}
                    </h2>
                    <div
                        className="d-flex flex-column flex-md-row p-4 gap-4 py-md-5 align-items-center justify-content-center">
                        <div className="list-group">
                            {studyList.map((item, index) =>
                                // <div
                                //     key={`study-${index+1}`}
                                //     className="list-group-item list-group-item-action d-flex gap-3 py-3"
                                //     aria-current="true">
                                //     🌱
                                //     <div className="d-flex gap-2 w-100 justify-content-between">
                                //         <div>
                                //             <h6 className="mb-0">{item.server}</h6>
                                //             <p className="mb-0 opacity-75">{item.content}</p>
                                //         </div>
                                //         <small className="opacity-50 text-nowrap">{item.period}</small></div>
                                // </div>
                                <div key={`study-${index + 1}`} className="list-group-item list-group-item-action py-3"
                                     aria-current="true"> 🌱 <div className="row w-100">
                                    <div className="col-12 col-md-8"><h6 className="mb-0">{item.server}</h6> <p
                                        className="mb-0 opacity-75">{item.content}</p></div>
                                    <div className="col-12 col-md-4 text-md-end"><small
                                        className="opacity-50">{item.period}</small></div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <hr/>
                {/*자격증*/}
                <div className="col-lg-6 mx-auto">
                    <h2>
                        {certificationTitle}
                    </h2>
                    <div className='flex-md-row p-4 gap-4 py-md-5 align-items-center justify-content-center'>
                    {certificationList.map((item,index) =>
                            <div className="list-group list-group-checkable d-grid gap-2 border-0"
                                key={`cert-${index+1}`}>
                                <label
                                    className="list-group-item rounded-3 py-3"
                                    htmlFor="listGroupCheckableRadios1">
                                    🚩 {item.content}
                                    <span className="d-block small opacity-50">
                                  {item.period}
                                </span>
                                </label>
                            </div>
                        )}
                    </div>
                </div>
                <hr/>
                {/* 기술 */}
                <div className="col-lg-6 mx-auto">
                    <h2>
                        {commonSkillsTitle}
                    </h2>
                    <div className='flex-md-row p-4 gap-4 py-md-5 align-items-center justify-content-center'>
                        <div className="d-flex flex-wrap gap-2 justify-content-center">
                            {skillList.map((item, index) =>
                                <span
                                    key={`skill-${index+1}`}
                                    className={skillClassMapData?.[item.type] || ''}>
                                    {/*<img className="rounded-circle me-1" width="24" height="24"*/}
                                    {/*     src="https://github.com/mdo.png" alt=""/>*/}
                                    {item.name}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Others